// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ad94d57ef4163cba00822ff134e0659c" + ".js";
};